module.exports = "/fonts/source-sans-pro-v11-cyrillic-ext_latin-700.ttf";